import { Map } from 'immutable';

import * as types from './types';
import * as constants from './constants';

const initialState = Map({
  device: null,
  sessionState: constants.MOBILE_SESSION_STATES.INITIAL,
});

const rdcPreviewSessionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.MOBILE_DEVICE_CONNECT.SUCCESS:
      return state.set('device', payload);
    case types.MOBILE_DEVICE_STATE_UPDATE: {
      switch (payload) {
        case constants.MOBILE_DEVICE_STATES.ONLINE:
          return state.set('sessionState', constants.MOBILE_SESSION_STATES.READY);
        case constants.MOBILE_DEVICE_STATES.OFFLINE:
          return state.set('sessionState', constants.MOBILE_SESSION_STATES.DEVICE_DISCONNECTED);
        default:
          return state.set('sessionState', constants.MOBILE_SESSION_STATES.PREPARING);
      }
    }
    case types.MOBILE_DEVICE_CONNECT.FAILURE:
    case types.MOBILE_DEVICE_DISCONNECT:
      return initialState;
    default:
      return state;
  }
};

export default rdcPreviewSessionReducer;
